import { memo, ReactNode, useMemo } from 'react'

import './index.scss'

type SplitButton = {
  options: { [key: string]: string | ReactNode }
  onClick: (key: string) => any
  value: string
  disabled?: boolean
  size: string // l, m, s
}

const SplitButton = memo(({
  options = {}, onClick = () => {}, value, disabled = false, size = 'l'
}: SplitButton) => {
  const className = useMemo(() => {
    const classArr = ['SplitButton']
    if (disabled) classArr.push('disabled')
    classArr.push(`size-${size}`)
    return classArr.join(' ')
  }, [disabled, size])

  return (
    <div className={className}>
      {Object.keys(options).map((key) => {
        const isSelected = key === value
        const label = options[key]
        return (
          <div
            className={`SplitButton__option${isSelected ? ' selected' : ''}`}
            role="button"
            tabIndex={0}
            onClick={!disabled ? () => onClick(key) : () => {}}
          >
            <div className="SplitButton__option-label">
              {label}
            </div>
          </div>
        )
      })}
    </div>
  )
})

export default SplitButton
